module.exports = __webpack_public_path__ + "static/img/01.0544529.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotkeSlider/01.jpg
// module id = CgQZ
// module chunks = 0